import { ComponentProps } from 'react';
import AntdPagination from 'antd/es/pagination';
import './style.scss';

export default function Pagination(props: ComponentProps<typeof AntdPagination>) {
    return <AntdPagination {...props} />;
}
